import {Button, styled} from "@mui/material";
import {ImgBox} from "../../../../../styles/layout/boxes";

export type TButtonProps = {
    active?: boolean
}

export const SideBarButtonBox = styled(
    Button, {
        shouldForwardProp: (propName: PropertyKey) => (!['active'].includes(propName.toString()))
    })<TButtonProps>(({active, ...props}) => ({
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '23.2px',
    border: 'solid 1px #fff',
    background: active ? '#FFFFFF' : 'unset',
    marginBottom: '2.6rem',
    boxShadow: active ? '3px 22px 18px 0 rgba(19, 19, 194, 0.11)' : 'unset',
    paddingTop: '1.6rem',

    '&:hover': {
        backgroundColor: active ? '#FFFFFF' : 'unset',
        boxShadow: '3px 22px 18px 0 rgba(19, 19, 194, 0.11)',
    },

    '&:disabled': {
        opacity: 0.38,
        backgroundColor: 'unset'
    }
}))

export const PixelStatusBox = styled(ImgBox)`
  position: absolute;
  top: -1.2rem;
  right: -1.2rem;
  width: 4.4rem;
  height: 4.4rem;
  background: #4e7cf7;
  border-radius: 50px;
  border: solid 1px #ffffff;
  padding: 1rem;
`

